// MOCK DATA for the International Securities & Exchange Commission of Sierra Leone (ISEC)
// All content below is mocked for a frontend-only prototype.

export const ORG = {
  shortName: "ISEC",
  name: "International Securities & Exchange Commission of Sierra Leone",
  acronym: "ISEC Sierra Leone",
  tagline: "Protecting investors. Promoting fair, efficient and transparent capital markets.",
  established: "Established under the Securities Industry Act",
  phone: "+232 22 226 501",
  altPhone: "+232 76 000 100",
  email: "info@isec.gov.sl",
  complaintsEmail: "complaints@isec.gov.sl",
  address: "3rd Floor, Bank Complex, Siaka Stevens Street, Freetown, Sierra Leone",
  hours: "Monday – Friday, 8:30 AM – 4:30 PM",
};

export const NAV = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Regulated Entities", path: "/regulated-entities" },
  { label: "Laws & Regulation", path: "/regulation" },
  { label: "News & Notices", path: "/news" },
];

export const HERO = {
  eyebrow: "Capital Markets Regulator · Republic of Sierra Leone",
  title: "Safeguarding integrity in Sierra Leone's securities markets",
  subtitle:
    "The International Securities & Exchange Commission of Sierra Leone licenses, supervises and regulates market intermediaries to protect investors and build confidence in our capital markets.",
  primaryCta: { label: "Search Regulated Entities", path: "/regulated-entities" },
  secondaryCta: { label: "File a Complaint", path: "/contact" },
};

export const STATS = [
  { value: "68", label: "Licensed Entities" },
  { value: "12", label: "Market Categories" },
  { value: "SLE 4.2B", label: "Market Capitalisation" },
  { value: "2002", label: "Year Established" },
];

export const QUICK_LINKS = [
  {
    icon: "Search",
    title: "Verify a Firm",
    desc: "Confirm whether a broker, dealer or adviser is licensed and active.",
    path: "/regulated-entities",
  },
  {
    icon: "ShieldAlert",
    title: "Report Misconduct",
    desc: "Report suspected fraud, unlicensed activity or market abuse.",
    path: "/contact",
  },
  {
    icon: "BookOpen",
    title: "Laws & Rules",
    desc: "Access the Securities Industry Act, rules and guidelines.",
    path: "/regulation",
  },
  {
    icon: "GraduationCap",
    title: "Investor Education",
    desc: "Learn how to invest safely and recognise investment scams.",
    path: "/about",
  },
];

export const FUNCTIONS = [
  {
    icon: "BadgeCheck",
    title: "Licensing & Registration",
    desc: "Authorising securities exchanges, brokers, dealers, advisers and collective investment schemes operating in Sierra Leone.",
  },
  {
    icon: "Eye",
    title: "Market Supervision",
    desc: "Monitoring market intermediaries for compliance with the Securities Industry Act and prudential standards.",
  },
  {
    icon: "Users",
    title: "Investor Protection",
    desc: "Safeguarding the interests of investors and the public against fraud, manipulation and unfair practices.",
  },
  {
    icon: "Scale",
    title: "Enforcement",
    desc: "Investigating breaches and taking disciplinary action including suspension and revocation of licences.",
  },
  {
    icon: "LineChart",
    title: "Market Development",
    desc: "Promoting the orderly growth of the securities market and broadening access to capital.",
  },
  {
    icon: "FileText",
    title: "Disclosure & Reporting",
    desc: "Ensuring timely, accurate disclosure of material information by issuers and market participants.",
  },
];

export const ENTITY_CATEGORIES = [
  "All Categories",
  "Securities Exchange",
  "Broker-Dealer",
  "Investment Adviser",
  "Fund Manager",
  "Issuing House",
  "Discount House",
  "Custodian",
  "Collective Investment Scheme",
  "Credit Rating Agency",
];

export const STATUSES = ["All Statuses", "Active", "Suspended", "Revoked"];

// Regulated entities -- only Name and Active status are the primary exposed fields,
// with category and licence reference for context.
export const ENTITIES = [
  { name: "Sierra Leone Stock Exchange", category: "Securities Exchange", license: "ISEC/EX/0001", status: "Active" },
  { name: "Freetown Capital Securities Ltd", category: "Broker-Dealer", license: "ISEC/BD/0102", status: "Active" },
  { name: "Rokel Investment Brokers Ltd", category: "Broker-Dealer", license: "ISEC/BD/0103", status: "Active" },
  { name: "Atlantic Securities (SL) Ltd", category: "Broker-Dealer", license: "ISEC/BD/0104", status: "Suspended" },
  { name: "Lion Mountain Stockbrokers Ltd", category: "Broker-Dealer", license: "ISEC/BD/0105", status: "Active" },
  { name: "Cotton Tree Dealers Ltd", category: "Broker-Dealer", license: "ISEC/BD/0106", status: "Active" },
  { name: "Bintumani Capital Partners", category: "Investment Adviser", license: "ISEC/IA/0201", status: "Active" },
  { name: "Aureol Advisory Services Ltd", category: "Investment Adviser", license: "ISEC/IA/0202", status: "Active" },
  { name: "Sherbro Wealth Advisers Ltd", category: "Investment Adviser", license: "ISEC/IA/0203", status: "Revoked" },
  { name: "Bo Heritage Advisory Ltd", category: "Investment Adviser", license: "ISEC/IA/0204", status: "Active" },
  { name: "Salone Asset Management Ltd", category: "Fund Manager", license: "ISEC/FM/0301", status: "Active" },
  { name: "Kono Diamond Fund Managers", category: "Fund Manager", license: "ISEC/FM/0302", status: "Active" },
  { name: "Makeni Growth Capital Ltd", category: "Fund Manager", license: "ISEC/FM/0303", status: "Suspended" },
  { name: "Western Area Asset Managers", category: "Fund Manager", license: "ISEC/FM/0304", status: "Active" },
  { name: "Freetown Issuing House Ltd", category: "Issuing House", license: "ISEC/IH/0401", status: "Active" },
  { name: "Pendembu Capital Issuers Ltd", category: "Issuing House", license: "ISEC/IH/0402", status: "Active" },
  { name: "Leone Bridge Issuing House", category: "Issuing House", license: "ISEC/IH/0403", status: "Revoked" },
  { name: "Central Discount House Ltd", category: "Discount House", license: "ISEC/DH/0501", status: "Active" },
  { name: "Sierra Discount & Securities Ltd", category: "Discount House", license: "ISEC/DH/0502", status: "Active" },
  { name: "Tower Hill Custodians Ltd", category: "Custodian", license: "ISEC/CU/0601", status: "Active" },
  { name: "Freetown Trust Custody Services", category: "Custodian", license: "ISEC/CU/0602", status: "Active" },
  { name: "Mano River Custody Ltd", category: "Custodian", license: "ISEC/CU/0603", status: "Suspended" },
  { name: "Salone Balanced Growth Fund", category: "Collective Investment Scheme", license: "ISEC/CIS/0701", status: "Active" },
  { name: "Diaspora Income Unit Trust", category: "Collective Investment Scheme", license: "ISEC/CIS/0702", status: "Active" },
  { name: "Freetown Money Market Fund", category: "Collective Investment Scheme", license: "ISEC/CIS/0703", status: "Active" },
  { name: "Heritage Equity Trust", category: "Collective Investment Scheme", license: "ISEC/CIS/0704", status: "Revoked" },
  { name: "West Africa Ratings Agency Ltd", category: "Credit Rating Agency", license: "ISEC/CRA/0801", status: "Active" },
  { name: "Salone Credit Analytics Ltd", category: "Credit Rating Agency", license: "ISEC/CRA/0802", status: "Active" },
  { name: "Kabala Highland Securities Ltd", category: "Broker-Dealer", license: "ISEC/BD/0107", status: "Active" },
  { name: "Port Loko Brokerage Services", category: "Broker-Dealer", license: "ISEC/BD/0108", status: "Active" },
  { name: "Kailahun Capital Advisers Ltd", category: "Investment Adviser", license: "ISEC/IA/0205", status: "Active" },
  { name: "Sulima Coastal Fund Managers", category: "Fund Manager", license: "ISEC/FM/0305", status: "Active" },
  { name: "Moa River Issuing House Ltd", category: "Issuing House", license: "ISEC/IH/0404", status: "Active" },
  { name: "Pademba Discount House Ltd", category: "Discount House", license: "ISEC/DH/0503", status: "Suspended" },
  { name: "Aberdeen Custody & Trust Ltd", category: "Custodian", license: "ISEC/CU/0604", status: "Active" },
  { name: "Leone Infrastructure Bond Fund", category: "Collective Investment Scheme", license: "ISEC/CIS/0705", status: "Active" },
  { name: "Bonthe Maritime Securities Ltd", category: "Broker-Dealer", license: "ISEC/BD/0109", status: "Revoked" },
  { name: "Tonkolili Mineral Capital Ltd", category: "Investment Adviser", license: "ISEC/IA/0206", status: "Active" },
  { name: "Njala Endowment Fund Managers", category: "Fund Manager", license: "ISEC/FM/0306", status: "Active" },
  { name: "Freetown Prime Custodians Ltd", category: "Custodian", license: "ISEC/CU/0605", status: "Active" },
];

export const NEWS = [
  {
    id: 1,
    tag: "Public Notice",
    date: "12 June 2025",
    title: "Warning against unlicensed online investment platform 'SaloneFX Pro'",
    excerpt:
      "The Commission cautions the public that SaloneFX Pro is not licensed to solicit investments in Sierra Leone. Investors are urged to verify all firms on the Regulated Entities register.",
  },
  {
    id: 2,
    tag: "Enforcement",
    date: "3 June 2025",
    title: "Licence of Sherbro Wealth Advisers Ltd revoked",
    excerpt:
      "Following an investigation into breaches of conduct of business rules, the Commission has revoked the licence of Sherbro Wealth Advisers Ltd with immediate effect.",
  },
  {
    id: 3,
    tag: "Market",
    date: "28 May 2025",
    title: "ISEC approves listing of new SLE 250m corporate bond",
    excerpt:
      "The Commission has approved the prospectus for a five-year corporate bond, deepening the domestic debt market and broadening investment options for the public.",
  },
  {
    id: 4,
    tag: "Consultation",
    date: "15 May 2025",
    title: "Public consultation: draft Collective Investment Schemes Rules 2025",
    excerpt:
      "Stakeholders are invited to submit written comments on the draft rules governing the establishment and operation of collective investment schemes by 30 June 2025.",
  },
  {
    id: 5,
    tag: "Investor Alert",
    date: "2 May 2025",
    title: "Recognising and avoiding Ponzi schemes",
    excerpt:
      "The Commission reminds investors that promises of guaranteed high returns with little or no risk are a hallmark of fraudulent schemes.",
  },
  {
    id: 6,
    tag: "Press Release",
    date: "21 April 2025",
    title: "ISEC signs MoU with regional securities regulators",
    excerpt:
      "A memorandum of understanding will strengthen cross-border supervision and information sharing among West African capital markets regulators.",
  },
];

export const LAWS = [
  { title: "Securities Industry Act", type: "Primary Legislation", year: "2021", desc: "The principal statute establishing the Commission and the framework for securities regulation in Sierra Leone." },
  { title: "Securities (Licensing) Rules", type: "Subsidiary Rules", year: "2022", desc: "Requirements and procedures for the licensing of market intermediaries." },
  { title: "Conduct of Business Rules", type: "Subsidiary Rules", year: "2022", desc: "Standards of conduct for licensed firms in dealings with clients." },
  { title: "Collective Investment Schemes Rules (Draft)", type: "Consultation", year: "2025", desc: "Draft rules governing the establishment and operation of collective investment schemes." },
  { title: "Listing Rules", type: "Exchange Rules", year: "2023", desc: "Eligibility and continuing obligations for issuers listed on the securities exchange." },
  { title: "Anti-Money Laundering Guidelines", type: "Guidelines", year: "2024", desc: "AML/CFT obligations for market intermediaries." },
];

export const LEADERSHIP = [
  { name: "Dr. Aminata B. Conteh", role: "Director-General", initials: "AC" },
  { name: "Mr. Mohamed S. Kamara", role: "Deputy Director-General, Supervision", initials: "MK" },
  { name: "Mrs. Fatmata Sesay-Bangura", role: "Director, Licensing & Authorisation", initials: "FB" },
  { name: "Mr. Ibrahim Y. Turay", role: "Director, Enforcement & Legal", initials: "IT" },
];

export const IMAGES = {
  about: "https://images.unsplash.com/photo-1573496130141-209d200cebd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxBZnJpY2FuJTIwYnVzaW5lc3MlMjBwcm9mZXNzaW9uYWxzfGVufDB8fHx8MTc4MTgwMjYzMnww&ixlib=rb-4.1.0&q=85",
  education: "https://images.unsplash.com/photo-1573164574397-dd250bc8a598?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxBZnJpY2FuJTIwYnVzaW5lc3MlMjBwcm9mZXNzaW9uYWxzfGVufDB8fHx8MTc4MTgwMjYzMnww&ixlib=rb-4.1.0&q=85",
  building: "https://images.unsplash.com/photo-1523292562811-8fa7962a78c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxnb3Zlcm5tZW50JTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgxODAyNjMyfDA&ixlib=rb-4.1.0&q=85",
  building2: "https://images.unsplash.com/photo-1573181759662-1c146525b21f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxnb3Zlcm5tZW50JTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgxODAyNjMyfDA&ixlib=rb-4.1.0&q=85",
  district: "https://images.unsplash.com/photo-1449157291145-7efd050a4d0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxmaW5hbmNpYWwlMjBkaXN0cmljdHxlbnwwfHx8fDE3ODE4MDI2MzJ8MA&ixlib=rb-4.1.0&q=85",
  district2: "https://images.unsplash.com/photo-1511883040705-6011fad9edfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBkaXN0cmljdHxlbnwwfHx8fDE3ODE4MDI2MzJ8MA&ixlib=rb-4.1.0&q=85",
};
